/*
 * © 2026 Ecsper Ltd. All rights reserved.
 * SPDX-License-Identifier: LicenseRef-Ecsper-Proprietary
 * Unauthorised use, copying, or distribution is strictly prohibited.
 */

import { ECSPER_DOCUMENT_NAMESPACE } from './constants.js';
import type { EcsperDocumentContext } from './schema-types.js';

export function escapeXmlText(value: string): string {
  return value
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&apos;');
}

/**
 * Serialises {@link EcsperDocumentContext} to the ECS-DD-MS365-001 SS B4.8 XML shape.
 */
export function buildEcsperDocumentXml(context: EcsperDocumentContext): string {
  const e = escapeXmlText;
  return (
    `<ecsperDocument xmlns="${ECSPER_DOCUMENT_NAMESPACE}">` +
    `<reportId>${e(context.reportId)}</reportId>` +
    `<projectId>${e(context.projectId)}</projectId>` +
    `<organisationId>${e(context.organisationId)}</organisationId>` +
    `<officeId>${e(context.officeId)}</officeId>` +
    `<residencyRegion>${e(context.residencyRegion)}</residencyRegion>` +
    `<schemaVersion>${e(context.schemaVersion)}</schemaVersion>` +
    `<plugin>${e(context.plugin)}</plugin>` +
    `<openedAt>${e(context.openedAt)}</openedAt>` +
    `<openedBy>${e(context.openedBy)}</openedBy>` +
    `</ecsperDocument>`
  );
}
